(function () {
  'use strict';

  function initCustomModal() {
    if (typeof jQuery === 'undefined') {
      setTimeout(initCustomModal, 100);
      return;
    }

    const $ = jQuery;
    const $modal = $('#customSearchModal');
    const $overlay = $modal.find(
      '.modal__overlay'
    );
    const $dialog = $modal.find('.modal__dialog');
    const $viewMenu = $modal.find(
      '[data-view="menu"]'
    );
    const $currentLabel = $modal.find(
      '[data-current-category-label]'
    );

    const DUR = 300;
    const EASE = 'swing';

    // SP判定（search_modal.jsと同じブレイクポイント）
    const isSPModal = () =>
      window.innerWidth <= 1023.5;

    // スクロールロック
    let scrollY = 0;

    // 初期状態
    $modal.hide();
    $overlay.css({ opacity: 0 });
    $dialog.css({
      opacity: 0,
      transform: isSPModal()
        ? 'translateX(-50%) translateY(20px)'
        : 'translate(-50%, -52%) scale(0.98)'
    });
    const isIOS = /iP(hone|od|ad)/.test(
      navigator.userAgent
    );
    // macOS Safari も含めたSafari判定
    const isSafari =
      isIOS ||
      (/Version\/[\d.]+.*Safari/.test(
        navigator.userAgent
      ) &&
        !/Chrome|Chromium|Android/.test(
          navigator.userAgent
        ));

    // スクロールイベントをキャンセルする関数
    function preventScroll(e) {
      e.preventDefault();
    }
    function lockScroll() {
      if (isSafari) {
        scrollY =
          window.scrollY || window.pageYOffset;
        document.body.style.top = `-${scrollY}px`;
        document.body.classList.add(
          'scroll-lock-ios'
        );
        document.addEventListener(
          'touchmove',
          preventScroll,
          { passive: false }
        );
      } else {
        document.body.classList.add(
          'scroll-lock'
        );
        document.addEventListener(
          'wheel',
          preventScroll,
          { passive: false }
        );
      }
    }
    function unlockScroll() {
      if (isSafari) {
        document.body.classList.remove(
          'scroll-lock-ios'
        );
        document.body.style.top = '';
        // iOSでスムーススクロールが走らないよう瞬時に戻す
        document.documentElement.style.scrollBehavior =
          'auto';
        document.body.style.scrollBehavior =
          'auto';
        window.scrollTo({
          top: scrollY,
          left: 0,
          behavior: 'instant'
        });
        // 少し遅延させてからscroll-behaviorを元に戻す
        setTimeout(function () {
          document.documentElement.style.scrollBehavior =
            '';
          document.body.style.scrollBehavior = '';
        }, 0);
        document.removeEventListener(
          'touchmove',
          preventScroll
        );
      } else {
        document.body.classList.remove(
          'scroll-lock'
        );
        document.removeEventListener(
          'wheel',
          preventScroll
        );
      }
    }

    function openModal(category, labelText) {
      // メニュー表示設定
      $viewMenu.removeClass('is-hidden');
      $viewMenu
        .find('.menu-list')
        .attr('hidden', true);
      $viewMenu
        .find(
          `.menu-list[data-menu-for="${category}"]`
        )
        .attr('hidden', false);
      $currentLabel.text(labelText || '');

      // モーダル表示
      $modal
        .show()
        .attr('aria-hidden', 'false')
        .css({ pointerEvents: 'none' });

      // アニメーション
      $overlay
        .stop(true, true)
        .animate({ opacity: 1 }, DUR, EASE);
      $dialog.stop(true, true).animate(
        { opacity: 1 },
        {
          duration: DUR,
          easing: EASE,
          step: function (now) {
            const p = now;
            if (isSPModal()) {
              const ty = 20 - 20 * p; // 20px → 0px
              $dialog.css(
                'transform',
                `translateX(-50%) translateY(${ty}px)`
              );
            } else {
              const ty = -52 + 2 * p;
              const sc = 0.98 + 0.02 * p;
              $dialog.css(
                'transform',
                `translate(-50%, ${ty}%) scale(${sc})`
              );
            }
          },
          complete: function () {
            $modal.css({ pointerEvents: 'auto' });
          }
        }
      );

      lockScroll();

      // ESCで閉じる
      $(document).on(
        'keydown.customModal',
        function (e) {
          if (e.key === 'Escape') closeModal();
        }
      );
    }

    let $lastTrigger = null;

    function closeModal() {
      // aria-hidden を設定する前にフォーカスをモーダル外へ移動する
      // （フォーカスを持ったままの子孫要素に aria-hidden をかけると警告が出るため）
      if ($lastTrigger && $lastTrigger.length) {
        $lastTrigger.trigger('focus');
      }

      $modal
        .attr('aria-hidden', 'true')
        .css({ pointerEvents: 'none' });

      $overlay
        .stop(true, true)
        .animate({ opacity: 0 }, DUR, EASE);
      $dialog.stop(true, true).animate(
        { opacity: 0 },
        {
          duration: DUR,
          easing: EASE,
          step: function (now) {
            const p = 1 - now;
            if (isSPModal()) {
              const ty = 20 * p; // 0px → 20px
              $dialog.css(
                'transform',
                `translateX(-50%) translateY(${ty}px)`
              );
            } else {
              const ty = -50 - 2 * p;
              const sc = 1 - 0.02 * p;
              $dialog.css(
                'transform',
                `translate(-50%, ${ty}%) scale(${sc})`
              );
            }
          },
          complete: function () {
            $modal
              .hide()
              .css({ pointerEvents: 'auto' });
            $dialog.css({
              opacity: 0,
              transform: isSPModal()
                ? 'translateX(-50%) translateY(20px)'
                : 'translate(-50%, -52%) scale(0.98)'
            });

            // モーダルが閉じたらページ全体を有効化
            $('body').removeClass(
              'page-disabled'
            );
          }
        }
      );

      unlockScroll();
      $(document).off('keydown.customModal');
    }

    // 新規ボタンのイベント
    $(document).on(
      'click',
      '[data-open-menu]',
      function () {
        $lastTrigger = $(this);
        const category =
          $(this).data('open-menu');
        const labelText = $(this).text().trim();
        openModal(category, labelText);
      }
    );

    // 閉じるボタン
    $modal.on(
      'click',
      '[data-close="button"], [data-close="overlay"]',
      closeModal
    );
    $modal.on(
      'click',
      '.back-button',
      closeModal
    );

    // URLパラメータからモーダルを開く
    function checkURLParams() {
      const params = new URLSearchParams(
        window.location.search
      );
      const modalParam = params.get('modal');

      if (modalParam) {
        const modalConfig = {
          internal:
            'CLLが疑われる、または診断された直後の方',
          hematology:
            'CLL診断後、治療せずに過ごす（経過観察する）方',
          clinic: '今から治療を開始される方',
          support: '治療を長く続けている方',
          online:
            '再び症状が出た方 / 治療効果が弱かった方（再発・難治性）'
        };

        if (modalConfig[modalParam]) {
          const $targetButton = $(
            `[data-open-menu="${modalParam}"]`
          );

          if ($targetButton.length > 0) {
            // ページ読み込み直後にページ全体を無効化
            $('body').addClass('page-disabled');

            setTimeout(() => {
              const headerHeight = 80;
              const buttonOffset =
                $targetButton.offset().top;
              const scrollPosition =
                buttonOffset - headerHeight - 130;

              // スクロール実行
              window.scrollTo(0, scrollPosition);

              // スクロール完了後にモーダルを開く
              setTimeout(() => {
                openModal(
                  modalParam,
                  modalConfig[modalParam]
                );

                // URLからパラメータを削除
                const newUrl =
                  window.location.pathname;
                window.history.replaceState(
                  {},
                  '',
                  newUrl
                );
              }, 1000);
            }, 300);
          }
        }
      }
    }

    // ページ読み込み時にURLパラメータをチェック
    checkURLParams();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initCustomModal
    );
  } else {
    initCustomModal();
  }
})();
